import { useAuth } from '@/lib/platform/AuthProvider';
import { useAppNavigation } from '@/lib/platform';
import { useEffect } from 'react';
import { useProfile } from '@/lib/api';
import { Loader } from '@/components/Loader';

interface AnalyticsRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard for analytics access - allows users with admin OR analytics role
 */
export default function AnalyticsRoute({ children }: AnalyticsRouteProps) {
  const { isSignedIn, isLoaded, openSignIn } = useAuth();
  const { navigate } = useAppNavigation();

  // Check if user has analytics access (only fetch when signed in)
  const { data: profile, isLoading } = useProfile({
    enabled: isSignedIn && isLoaded,
  });

  // hasAnalyticsAccess includes analytics role OR admin role
  const hasAnalyticsAccess = (profile?.data as { hasAnalyticsAccess?: boolean })?.hasAnalyticsAccess || profile?.data?.isAdmin;

  useEffect(() => {
    if (isLoaded && !isSignedIn) {
      openSignIn({ preventClose: true });
    } else if (!isLoading && isSignedIn && !hasAnalyticsAccess) {
      navigate('/dashboard');
    }
  }, [isLoaded, isSignedIn, isLoading, hasAnalyticsAccess, navigate, openSignIn]);

  if (!isLoaded || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (!isSignedIn || !hasAnalyticsAccess) {
    return null;
  }

  return <>{children}</>;
}

